// Copyright (c) 2021, Comsearch, Inc., All rights reserved

import { BULK_EDITS_FILTER } from 'components/BulkUpdates/constants'
import getBulkEditPathsFilteredByBandId from 'redux/modules/bulkEdit/thunks/getBulkEditPathsFilteredByBandId'
import getVisibleSegmentEndIds from 'redux/modules/bulkEdit/thunks/getVisibleSegmentEndIds'
import getSegmentEndIdsFilteredByValue from './getSegmentEndIdsFilteredByValue'
import getSegmentEndIdsWithEmptyValue from './getSegmentEndIdsWithEmptyValue'

// This thunk returns the segment end ids which match the BULK_EDITS_FILTER values
// NOTE - if no filtering values are assigned there, this thunk will return an array
// of all visible segment ends

const getFilteredSegmentEndIds = () => (dispatch, getState) => {
  const { form } = getState()

  const {
    filterCheckbox,
    filterInput,
    filterSelect,
  } = form[BULK_EDITS_FILTER].values

  const bulkEditPaths = dispatch(getBulkEditPathsFilteredByBandId())

  // just in case, we make sure that there are filter values
  if (filterCheckbox === false && filterInput.length === 0) {
    return dispatch(getVisibleSegmentEndIds())
  }

  return (
    // if checked
    filterCheckbox
      // we want to filter by segment ends which do not have the specified field defined
      ? getSegmentEndIdsWithEmptyValue(bulkEditPaths, filterSelect)
      // else we want to filter by substring with the text input field.
      : getSegmentEndIdsFilteredByValue(bulkEditPaths, filterInput, filterSelect)
  )
}

export default getFilteredSegmentEndIds
